import { render, staticRenderFns } from "./ConfigurationCurr.vue?vue&type=template&id=fed33dda"
import script from "./ConfigurationCurr.vue?vue&type=script&lang=js"
export * from "./ConfigurationCurr.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationCurr.vue?vue&type=style&index=0&id=fed33dda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports